import { render } from "./BookingsTable.vue?vue&type=template&id=2eafccf4&scoped=true"
import script from "./BookingsTable.vue?vue&type=script&lang=js"
export * from "./BookingsTable.vue?vue&type=script&lang=js"

import "./BookingsTable.vue?vue&type=style&index=0&id=2eafccf4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2eafccf4"

export default script